import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { requestStudentDataCSV } from './action';
import { generateCSVStringFromJSON } from 'utilities/file';
import './style.scss';
import moment from 'moment';

class ExportCSVButton extends React.Component {
  constructor(props) {
    super(props);
    this.linkRef = React.createRef();
  }

  download(fileName = 'studentsData.csv', text) {
    const holder = this.linkRef.current;
    holder.setAttribute('href', 'data:text/plain;charset=utf-8,%EF%BB%BF' + encodeURIComponent(text));
    holder.setAttribute('download', fileName);
    holder.click();
  }

  clickHandler = (e) => {
    e.preventDefault();
    this.props.requestStudentDataCSV(this.props.eventId)
      .then(data => {
        let arrayData = [];
        arrayData = arrayData.concat(data.requestedUsers.map(user => { user.joinStatus = '応募中'; return user;}));
        arrayData = arrayData.concat(data.joinedUsers.map(user => { user.joinStatus = '参加確定'; return user;}));
        arrayData = arrayData.concat(data.deniedUsers.map(user => { user.joinStatus = '辞退'; return user;}));
        
        this.download(this.props.fileName, generateCSVStringFromJSON(arrayData, STUDENT_STRUCT));
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    return (
      <Fragment>
        <div className="event-detail-export-csv" onClick={this.clickHandler} >
          <img alt="" src="/images/download.svg" />
          CSVファイルをダウンロード
        </div>
        <a 
          href='# '
          ref={this.linkRef} 
          id='exportEventDetailCSV'
          style={{display: 'none'}}
        >
          {null}
        </a>
      </Fragment>
      
    );
  }
}

const STUDENT_STRUCT = {
  '状態': 'joinStatus',
  '応募日時': {path: 'requestedAt', format: value => (value ? moment(value).format('YYYY/MM/DD HH:mm:ss') : '')},
  '卒業見込み年': 'studentProfile.graduationYear',
  '名前': 'fullname',
  'ふりがな': 'nameHiragana',
  '性別': {path: 'gender', format: value => {
    if (value === 'MALE') {
      return '男性';
    }

    if (value === 'FEMALE') {
      return '女性';
    }

    if (value === 'NEITHER') {
      return 'どちらでもない';
    }
    
    return '';
  }},
  '生年月日': {path: 'birthday', format: value => (value ? moment().diff(moment(value), 'years') : '')},
  '学校名': 'studentProfile.university',
  '学部学科': 'studentProfile.major',
  '文理区分': 'studentProfile.majorCategory',
  '部活・サークル': 'studentProfile.club',
  'メールアドレス': 'email',
  '電話': 'phone',
  '応募時のメッセージ': 'reason',
  '自己 ＰＲ': 'studentProfile.introduction',
  '将来の目標': 'studentProfile.yourDream',
  '資格・過去の実績・制作物など': 'studentProfile.portfolio',
  '出身高校名': 'studentProfile.highSchool'
};

ExportCSVButton.propTypes = {
  eventId: PropTypes.string,
  fileName: PropTypes.string,
  requestStudentDataCSV: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({
  requestStudentDataCSV: (eventId) => dispatch(requestStudentDataCSV(eventId))
});

export default connect(
  null, mapDispatchToProps
)(ExportCSVButton);

